// The browser may refuse its storage (private window, blocked site data): nothing is read, and
// what is written lasts for this session only.

export const readStored = (key: string): string | null => {
    try {
        return localStorage.getItem(key);
    } catch {
        return null;
    }
};

export const writeStored = (key: string, value: string) => {
    try {
        localStorage.setItem(key, value);
    } catch {
        // Storage refused: the value lasts for this session only.
    }
};

export const removeStored = (key: string) => {
    try {
        localStorage.removeItem(key);
    } catch {
        // Nothing kept: nothing to remove.
    }
};
